export default __webpack_public_path__ + "static/media/roboto-latin-100.a45108d3.woff";